import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {Column, useTable} from "react-table";
import * as commonColumnFormatters from '../../_common/column-formatters';
import {formattingPrice} from '../../_common/utils/format';
import {LawTransactionsRow} from "../types";
import useInfiniteScrollControl from "../../_common/components/_custom-hooks/useInfiniteScrollControl";
import * as actions from "../_redux/lawActions";
import CommonGrid from "../../_common/components/CommonGrid";
import {useLawTransactionsContext} from "../context/LawTransactionsContext";

export function TableTransactions() {
  const prefix = 'law-column';
  const {formatMessage} = useIntl();
  const [tableRows, setTableRows] = useState<LawTransactionsRow[]>([]);
  const columns: Column<LawTransactionsRow>[] = useMemo(() => [
    {
      accessor: 'agentId',
      Header: formatMessage({id: `${prefix}-agentID`, defaultMessage: 'Agent ID'})
    },
    {
      accessor: 'agentName',
      Header: formatMessage({id: `${prefix}-agentName`, defaultMessage: 'Name'})
    },
    {
      accessor: 'date',
      Header: formatMessage({id: `${prefix}-date`, defaultMessage: 'Date'})
    },
    {
      accessor: 'transactionType',
      Header: formatMessage({id: `${prefix}-transactionType`, defaultMessage: 'Type'})
    },
    {
      accessor: 'internalCode',
      Header: formatMessage({id: `${prefix}-internalCode`, defaultMessage: 'Internal code'})
    },
    {
      accessor: 'amount',
      Header: formatMessage({id: `${prefix}-amount`, defaultMessage: 'Amount'})
    },
  ], [formatMessage]);
  const data = useMemo(() => [
    ...tableRows
      .map((item) => {

        return {
          agentId: commonColumnFormatters.BoldColumnFormatter(item.agentId),
          agentName: commonColumnFormatters.BoldColumnFormatter(item.agentName),
          date: commonColumnFormatters.DateColumnFormatter(item.date),
          transactionType: commonColumnFormatters.BoldColumnFormatter(item.transactionType),
          internalCode: commonColumnFormatters.BoldColumnFormatter(item.internalCode),
          amount: commonColumnFormatters.BoldColumnFormatter(formattingPrice(item.amount)),
        };
      })
  ], [tableRows]);

  const tableInstance = useTable<LawTransactionsRow>({columns, data});

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'lawTransactions',
    UIContext: useLawTransactionsContext(),
    getNewEntities: actions.getLawTransactions,
    getNextEntities: actions.getNextLawTransactions,
    onEntitiesChange: (entities: LawTransactionsRow[]) => setTableRows(entities),
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={tableInstance}
      customScrollContainerID={'custom-law-container'}
      customTableStyles={'law-table-transactions'}
    />
  );
}

